export const CREATE_ACCOUNT  = 'CREATE_ACCOUNT';
export const GET_ACCOUNT  = 'GET_ACCOUNT';
export const ACCOUNT_REQUEST  = 'ACCOUNT_REQUEST';
export const DELETE_ACCOUNT  = 'DELETE_ACCOUNT';
export const UPDATE_ACCOUNT  = 'UPDATE_ACCOUNT';
export const ACCOUNT_REQUEST_FAILURE  = 'ACCOUNT_REQUEST_FAILURE';
export const GET_ACCOUNTS_PAGE  = 'GET_ACCOUNTS_PAGE';
export const GET_ACCOUNT_BY_ID_REQUEST  = 'GET_ACCOUNT_BY_ID_REQUEST';
export const ACCOUNT_REQUEST_SUCCESS  = 'ACCOUNT_REQUEST_SUCCESS';

